import CheckboxSelectAll from "@stimulus-components/checkbox-select-all";

// Connects to data-controller="checkbox-select-all"
export default class extends CheckboxSelectAll {
  connect() {
    super.connect();
  }
}
